"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var backToFinanceButtonStyles = styles_1.makeStyles(function (theme) { return ({
    buttonWrapper: {
        height: 40,
        borderRadius: 0,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        maxWidth: '100%',
        padding: '0 40px',
        width: 'auto',
        '&:hover': {
            borderColor: theme.palette.secondary.main,
        },
    },
    buttonLabel: {
        fontSize: theme.typography.fontXS,
        fontWeight: 500,
    },
}); }, { name: 'Checkout_BackToFinanceButton' });
exports.default = backToFinanceButtonStyles;
